// templates/component/SignInBannerTsx.js
import React from 'react'

interface SignInBannerProps {
    text: string
    isBannerGlow: boolean
    show: boolean
    classes: string
}
function SignInBanner(props: SignInBannerProps) {
    if (props.show) {
        return (
            <div
                id="signin_banner"
                className={`text-center mt-1 px-3 py-2 ${props.classes} ${props.isBannerGlow ? 'highlightBanner' : ''}`}
                dangerouslySetInnerHTML={{ __html: props.text }}
            ></div>
        )
    } else {
        return <></>
    }
}

export default SignInBanner
